$(document).ready(function() {
  var currentTime = new Date(); 
  var index = $(location).attr('href')
  //console.log(url);

  try{
    if(localStorage.getItem("popup_cstm")  == "yes" && window.location.pathname.indexOf("cart") == -1 ){
      localStorage.setItem("popup_cstm","")
    }
  }catch(e){console.log(e ," index.js popupcstm")}

  // get current time  0= Sunday, 1= Monday, 2= Tue, 3= Wed, 4= thu, 5= friday 6= sat
  // if day is mon-Fri and time is between 8am and 4pm
  //var d = new Date();

  var d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"}));
  var dayOfWeek = d.getDay();
  var hour = d.getHours();
  var mins = d.getMinutes();
  var status = 'live';

  if (dayOfWeek !== 0 && dayOfWeek !== 6 && hour >= 8 && hour < 16){   
    status = 'live';    
  }else{
    status = 'afterHours';
  }

  if (status=='live') {
    $(".custom-product .help").css("display","inline-block");
  }
  else{
    $(".custom-product .after-hours.typeform").css("display","inline-block");    
  } 

  if(window.outerWidth <=767) {
    //alert('mobile');
    $('.def-content br').remove();
  } 

  var extended = $(location).attr('href')
  var string = extended.substring(extended.lastIndexOf('/'));
  //console.log(string); 
  if(string =='/extended-warranties'){  	 
  }

  function refreshAt(hours, minutes, seconds) {
    var now = new Date();
    var then = new Date();
    if(now.getHours() > hours ||
       (now.getHours() == hours && now.getMinutes() > minutes) ||
       now.getHours() == hours && now.getMinutes() == minutes && now.getSeconds() >= seconds) {
      then.setDate(now.getDate() + 1);
    }
    then.setHours(hours);
    then.setMinutes(minutes);
    then.setSeconds(seconds);
    var timeout = (then.getTime() - now.getTime());
    setTimeout(function() { window.location.reload(true); }, timeout);
  }

  $(".shogun-accordion-title").click(function () {
    if(window.outerWidth <=767) {
      //alert("Test");
      $('html, body').animate({
        scrollTop: $(".shogun-accordion-body.shogun-accordion-active").offset().top
      }, 100);
    }
  });

  // Scroll sticky  
  $(window).scroll(function(){
    var sticky = $('.sticky'),
        scroll = $(window).scrollTop();

    if (scroll >= 130) sticky.addClass('fixed');
    else sticky.removeClass('fixed');

    var windowWidth = $(window).width();
    if(windowWidth <= 1024 ) {
      //var sticky = $('.custom-product .sticky-mobile'),
      //scroll = $(window).scrollTop();

      if (scroll >= 700) sticky.addClass('fixed');
      else sticky.removeClass('fixed');

    }
  });

  $(window).scroll(function(){
    if ($(window).scrollTop() >= 680) {
      $('.shg-product .shogun-tabs').addClass('fixed-header');       
    }
    else {
      $('.shg-product .shogun-tabs').removeClass('fixed-header');        
    }
  });

  $('.shg-product .shogun-tab').on('click', function(e) {
    e.preventDefault();            
    if(window.outerWidth <=767) {
      //alert('moe');
      $('html, body').animate({
        scrollTop: $(".shogun-tab-content.shogun-tab-active").offset().top
      }, 300);
    } else {
      $('html, body').animate({
        scrollTop: $(".shogun-tab-content.shogun-tab-active").offset().top
      }, 1500);
    }
  });

  // ===== Scroll to Top ==== 
  $(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
      $('#return-to-top').fadeIn(200);    // Fade in the arrow
    } else {
      $('#return-to-top').fadeOut(200);   // Else fade out the arrow
    }
  });
  $('#return-to-top').click(function() {      // When arrow is clicked
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
    }, 500);
  });

  //  Youtube code   
   $.fn.YouTubePopUp = function(options) {

     var YouTubePopUpOptions = $.extend({
       autoplay: 1
     }, options );

     $(this).on('click', function (e) {

       var youtubeLink = $(this).attr("href");

       if( youtubeLink.match(/(youtube.com)/) ){
         var split_c = "v=";
         var split_n = 1;
       }

       if( youtubeLink.match(/(youtu.be)/) || youtubeLink.match(/(vimeo.com\/)+[0-9]/) ){
         var split_c = "/";
         var split_n = 3;
       }

       if( youtubeLink.match(/(vimeo.com\/)+[a-zA-Z]/) ){
         var split_c = "/";
         var split_n = 5;
       }

       var getYouTubeVideoID = youtubeLink.split(split_c)[split_n];

       var cleanVideoID = getYouTubeVideoID.replace(/(&)+(.*)/, "");

       if( youtubeLink.match(/(youtu.be)/) || youtubeLink.match(/(youtube.com)/) ){
         var videoEmbedLink = "https://www.youtube.com/embed/"+cleanVideoID+"?autoplay="+YouTubePopUpOptions.autoplay+"";
       }

      if( youtubeLink.match(/(vimeo.com\/)+[0-9]/) || youtubeLink.match(/(vimeo.com\/)+[a-zA-Z]/) ){
         var videoEmbedLink = "https://player.vimeo.com/video/"+cleanVideoID+"?autoplay="+YouTubePopUpOptions.autoplay+"";
       }

       $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+videoEmbedLink+'" allowfullscreen></iframe></div></div>');

       if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
         setTimeout(function() {
           $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
         }, 600);
       }

       $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
         $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
       });

       e.preventDefault();

     });

     $(document).keyup(function(e) {

       if ( e.keyCode == 27 ){
         $('.YouTubePopUp-Wrap, .YouTubePopUp-Close').click();
       }

     });

   }

   $("a.video").YouTubePopUp();  
   $(".product-mobile a.video-svg").YouTubePopUp(); 
  
  // // Counter  
  // $('.count').each(function () {
  //   $(this).prop('Counter',0).animate({
  //     Counter: $(this).text()
  //   }, {
  //     duration: 4000,
  //     easing: 'swing',
  //     step: function (now) {
  //       $(this).text(Math.ceil(now));
  //     }
  //   });
  // });

  //Page pop up
  var url = window.location.href;
  var c = url.substring(url.lastIndexOf('/') + 1);
  //console.log(c);
  if(c=='defender-phoenix-with-2-camera-phoenixm22c'){  
    //alert('Popup');
    //$("body").append("<div class='product-overlay'><div class='productBox' id='productBox'><a class='close'></a><div class='split left'><div class='centered'><img src='https://cdn.shopify.com/s/files/1/0276/7831/0503/t/2/assets/phoenixM22C.jpg' alt='Phoneix'></div></div><div class='split right'><div class='centered'><h1>Oops!</h1><div class='right-check'>We're out of stock of this item.Check out the Refurbished option and <strong>Save 40%!</strong></div><a href='/products/phoenixm22c-wireless-security-system-with-2-x-digital-cameras-and-7-lcd-monitor' class='shop'>Shop Now</a></div></div></div></div>");
    //$("body").addClass( "no-scroll" );		
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.product-overlay, .close', function() {
      $('.product-overlay').remove();
      $("body").removeClass( "no-scroll" );
    });

    // CLOSE THE POPUP
    $('body').on('click','.productBox', function(e) {
      e.stopPropagation();
    });  

  }

  //Refurbished button on the Category page  
  var url = window.location.href;
  var ref = url.substring(url.lastIndexOf('/') + 1);
  //console.log(ref);
  if (ref=="wireless-security"){

    //Phoneix 2 cameras
    var anchor = document.querySelector('.collection-alternating-product:nth-child(5) .collection-alternating-content a.collection-button'),
        phoneix = anchor.getAttribute('href');
    //console.log(phoneix);          
    var Sout =  $(".collection-alternating-product:nth-child(5) .collection-alternating-content .sold-out").text();
    //console.log(Sout);           
    if ((phoneix=='/collections/wireless-security/products/defender-phoenix-with-2-camera-phoenixm22c') && (Sout==' Sold out')){
      $(".collection-alternating-product:nth-child(5) .collection-alternating-content .refurbished").append("<a class='refurb button outline collection-button' href='/products/phoenixm22c-wireless-security-system-with-2-x-digital-cameras-and-7-lcd-monitor'>Shop Refurbished<span class='icon icon-arrow-right'></span></a>");
    }     


    // Phoneix 1 Cameras
    var anchor = document.querySelector('.collection-alternating-product:nth-child(4) .collection-alternating-content a.collection-button'),
        phoneix1 = anchor.getAttribute('href');
    //console.log(phoneix1);          
    var Sout1 =  $(".collection-alternating-product:nth-child(4) .collection-alternating-content .sold-out").text();
    //console.log(Sout);           
    if ((phoneix1=='/collections/wireless-security/products/defender-phoenix-with-1-camera-phoenixm2') && (Sout1==' Sold out')){
      $(".collection-alternating-product:nth-child(4) .collection-alternating-content .refurbished").append("<a class='refurb button outline collection-button' href='/products/phoenixm2-wireless-security-system-with-1-x-digital-cameras-and-7-lcd-monitor'>Shop Refurbished<span class='icon icon-arrow-right'></span></a>");
    }

    // Guard Refurbished      
    var anchor = document.querySelector('.collection-alternating-product:nth-child(1) .collection-alternating-content a.collection-button'),
        Guard = anchor.getAttribute('href');
    //console.log(Guard);
    var Sold =  $(".collection-alternating-product:nth-child(1) .collection-alternating-content .sold-out").text();
    //console.log(Sold);  

    if ((Guard=='/collections/wireless-security/products/defender-guard-2k-wi-fi-camera-ip4mcb1') && (Sold==' Sold out')){
      $(".collection-alternating-product:nth-child(1) .collection-alternating-content .refurbished").append("<a class='refurb button outline collection-button' href='/products/defender-4mp-outdoor-wi-fi-ip-camera-with-16gb-sd-card'>Shop Refurbished<span class='icon icon-arrow-right'></span></a>");
    }      

  } 


  //Deals page banner page  
  var url = window.location.href;
  var wiredref = url.substring(url.lastIndexOf('/') + 1);
  //console.log(ref);
  if(wiredref=='deals'){
    //alert('deals');
    $('.content').addClass('deals');
  }

  // Accordion tabs
  // var $titleTab = $('.wired .title_tab');
  // //$('.Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  // //$('.Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  // $titleTab.on('click', function(e) {
  //   e.preventDefault();
  //   if ( $(this).hasClass('active') ) {
  //     $(this).removeClass('active');
  //     $(this).next().stop().slideUp(500);
  //     $(this).next().find('p').removeClass('show');
  //   } else {
  //     $(this).addClass('active');
  //     $(this).next().stop().slideDown(500);
  //     $(this).parent().siblings().children('.title_tab').removeClass('active');
  //     $(this).parent().siblings().children('.inner_content').slideUp(500);
  //     $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
  //     $(this).next().find('p').addClass('show');         	
  //     $('html, body').animate({scrollTop: $(".wired-looking").offset().top}, 2000);
  //   }
  // });

// new js accordion for wired dvr page accordions for 4cameras
  var $titleTab = $('.wired .Accordion_item:nth-child(1) .title_tab');
  
$titleTab.on('click', function(e) {
  e.preventDefault();
  if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    $(this).parent().find('.inner_content').css('display','none');
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
    $(this).parent().find('.inner_content').css('display','block');
      $(this).next().find('p').addClass('show');         	
    }
});

   // new js accordion for wired dvr page accordions for 8cameras
  var $titleTab2 = $('.wired .Accordion_item:nth-child(2) .title_tab');
  $titleTab2.addClass('active');
     $titleTab2.parent().find('.inner_content').css('display','block');
$titleTab2.on('click', function(e) {
  e.preventDefault();
  if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    $(this).parent().find('.inner_content').css('display','none');
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
    $(this).parent().find('.inner_content').css('display','block');
      $(this).next().find('p').addClass('show');         	
    }
});

   // new js accordion for wired dvr page accordions for 16cameras
  var $titleTab3 = $('.wired .Accordion_item:nth-child(3) .title_tab');
  $titleTab3.addClass('active');
     $titleTab3.parent().find('.inner_content').css('display','block');
$titleTab3.on('click', function(e) {
  e.preventDefault();
  if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    $(this).parent().find('.inner_content').css('display','none');
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
    $(this).parent().find('.inner_content').css('display','block');
      $(this).next().find('p').addClass('show');         	
    }
});

    // new js accordion for wired dvr page accordions for 4cameras
  var $titleTab4 = $('.wired .Accordion_item:nth-child(4) .title_tab');
$titleTab4.on('click', function(e) {
  e.preventDefault();
  if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    $(this).parent().find('.inner_content').css('display','none');
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
    $(this).parent().find('.inner_content').css('display','block');
      $(this).next().find('p').addClass('show');         	
    }
});

    // new js accordion for wired dvr page accordions for 4cameras
  var $titleTab5 = $('.wired .Accordion_item:nth-child(5) .title_tab');
  $titleTab5.on('click', function(e) {
  e.preventDefault();
  if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    $(this).parent().find('.inner_content').css('display','none');
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
    $(this).parent().find('.inner_content').css('display','block');
      $(this).next().find('p').addClass('show');         	
    }
});
  
    // new js accordion for wired dvr page accordions for 4cameras
  var $titleTab6 = $('.wired .Accordion_item:nth-child(6) .title_tab');
$titleTab6.on('click', function(e) {
  e.preventDefault();
  if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    $(this).parent().find('.inner_content').css('display','none');
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
    $(this).parent().find('.inner_content').css('display','block');
      $(this).next().find('p').addClass('show');         	
    }
});
  
// wireless Accordion tabs
  var $wirelessTab = $('.wireless .title_tab');
  //$('.Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  //$('.Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $wirelessTab.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
      $(this).next().find('p').addClass('show');         	
      $('html, body').animate({scrollTop: $(".wireless").offset().top}, 2000);
    }
  });
  // Guard Accordion tabs
  var $GuardTab = $('.guard .title_tab');
  $('.guard .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.guard .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $GuardTab.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
      $(this).next().find('p').addClass('show');         	
      $('html, body').animate({scrollTop: $(".guard").offset().top}, 2000);
    }
  });

  // phoenix Accordion tabs
  var $PhoenixTab = $('.phoenix .title_tab');
  $('.phoenix .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.phoenix .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $PhoenixTab.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
      $(this).next().find('p').addClass('show');         	
      $('html, body').animate({scrollTop: $(".phoenix").offset().top}, 2000);
    }
  });
  // ptz_open_box Accordion tabs
  var $ptz_open_box = $('.ptz_open_box .title_tab');
  $('.ptz_open_box .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.ptz_open_box .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $ptz_open_box.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".ptz_open_box").offset().top}, 2000);
    }
  });

    // guard_pro_obox Accordion tabs
  var $guard_pro_obox = $('.guard_pro_obox .title_tab');
  $('.guard_pro_obox .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.guard_pro_obox .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $guard_pro_obox.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".guard_pro_obox").offset().top}, 2000);
    }
  });

    // guard_obox Accordion tabs
  var $guard_obox = $('.guard_obox .title_tab');
  $('.guard_obox .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.guard_obox .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $guard_obox.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".guard_obox").offset().top}, 2000);
    }
  });

    // phoenix Accordion tabs
  var $phoenix_obox = $('.phoenix_obox .title_tab');
  $('.phoenix_obox .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.phoenix_obox .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $phoenix_obox.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".phoenix_obox").offset().top}, 2000);
    }
  });
  
    // sentinel 4k open box accessories Accordion tabs
  var $phoenix_obox_acc = $('.4k_opensen_acc .title_tab');
  $('.4k_opensen_acc .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.4k_opensen_acc .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $phoenix_obox_acc.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".4k_opensen_acc").offset().top}, 2000);
    }
  });

  // vision 4k open box accessories Accordion tabs
  var $4k_visopen_acc = $('.4k_visopen_acc .title_tab');
  $('.4k_visopen_acc .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.4k_visopen_acc .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $4k_visopen_acc.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".4k_visopen_acc").offset().top}, 2000);
    }
  });

    //  4k open box accessories Accordion tabs
  var $4k_open_acc = $('.4k_open_acc .title_tab');
  $('.4k_open_acc .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.4k_open_acc .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $4k_open_acc.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".4k_open_acc").offset().top}, 2000);
    }
  });

  //  guard pro ptz open box accessories Accordion tabs
  var $guard_ptz_acca = $('.guard_ptz_acca .title_tab');
  $('.guard_ptz_acca .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.guard_ptz_acca .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $guard_ptz_acca.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".guard_ptz_acca").offset().top}, 2000);
    }
  });

    //  guard pro open box accessories Accordion tabs
  var $gpro_open_acc = $('.gpro_open_acc .title_tab');
  $('.gpro_open_acc .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.gpro_open_acc .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $gpro_open_acc.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".gpro_open_acc").offset().top}, 2000);
    }
  });


   //  guard  open box accessories Accordion tabs
  var $guard_acc_open = $('.guard_acc_open .title_tab');
  $('.guard_acc_open .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.guard_acc_open .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $guard_acc_open.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".guard_acc_open").offset().top}, 2000);
    }
  });


   //  PhoenixM2  open box accessories Accordion tabs
  var $phoenix_oboxa = $('.phoenix_oboxa .title_tab');
  $('.phoenix_oboxa .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('.phoenix_oboxa .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $phoenix_oboxa.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".phoenix_oboxa").offset().top}, 2000);
    }
  });

       //  what is  open box  Accordion tabs
  var $guardnew2 = $('.guard-new2 .title_tab');

  $('.guard-new2 .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $guardnew2.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".guard-new2").offset().top}, 2000);
    }
  });


  

  //Accessories Accordion tabs	
  var $AccessoriesTab = $('.4k .title_tab');
  //$('.4k .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $AccessoriesTab.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".4k").offset().top}, 2000);
    }
  });


  //Accessories Anchor tab
  var url = window.location.href;
  var anchor = url.substring(url.lastIndexOf('#') + 1);
  //console.log(anchor);
  if(anchor=='resolution'){
    $("#resolution .Accordion_item .title_tab").addClass('active');
    $("#resolution .Accordion_item .inner_content").css("display", "block");
  }

  var $AccessoriesTab1 = $('.gsc .title_tab');
  $AccessoriesTab1.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".gsc").offset().top}, 2000);
    }
  });

  var $AccessoriesTab2 = $('.M2 .title_tab');
  $AccessoriesTab2.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $(".M2").offset().top}, 2000);
    }
  });

  //Certifeid OpenBox Accordion tabs
  var $OpenTab = $('#open_box .title_tab');
  $('#open_box .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('#open_box .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $OpenTab.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $('html, body').animate({scrollTop: $("#open_box").offset().top}, 2000);
    }
  });

  //Shop Refurbished button on the Wired Category/Collection New page  
  var url = window.location.href;
  var wiredref = url.substring(url.lastIndexOf('/') + 1);
  //console.log(ref);
  if(wiredref=='wired-security-systems' || wiredref == 'extended-warranties' || wiredref == 'extended-warranties#your-product'){     
    $(".wired-category-row .wired-category-col .wired-product div:nth-child(3) h2").text("2 YEAR");
    $(".wired-category-row .wired-category-col .wired-product div:nth-child(4) h2").text("3 YEAR");

  }



  //Pre Order button on the Axccesories PhoenixM2 Additional Security Camera            
  var url = window.location.href;
  var phoneixM2 = url.substring(url.lastIndexOf('/') + 1);
  //console.log(phoneixM2);
  if(phoneixM2=='phoenixm2c-digital-camera-for-wireless-security-system-1'){
    //alert('in');
    //$(".button.inverse").attr("value","PRE-ORDER");
  }

  //Read More Cart Message 
  if(window.outerWidth<=900) {
    // Hide the extra content initially, using JS so that if JS is disabled, no problem:
    $('.read-more-content').addClass('hide')
    $('.read-more-show, .read-more-hide').removeClass('hide')

    // Set up the toggle effect:
    $('.read-more-show').on('click', function(e) {
      $(this).next('.read-more-content').removeClass('hide');
      $(this).addClass('hide');
      e.preventDefault();
    });

    $('.read-more-hide').on('click', function(e) {
      var p = $(this).parent('.read-more-content');
      p.addClass('hide');
      p.prev('.read-more-show').removeClass('hide'); // Hide only the preceding "Read More"
      e.preventDefault();
    });
  }

  //ADD  ID for Accordion for Store Policies  
  $(".store .shogun-accordion-wrapper .shogun-accordion").each(function(i, v) {
    $(this).attr('id', "tab-" + i)
  })
  //$('.store #tab-2').hide();
  var acc_url = window.location.href;
  var acc = acc_url.substring(acc_url.lastIndexOf('#') + 1);
  //console.log(c);
  if (acc == 'tab-0') {
    var id = url.substring(url.lastIndexOf('#'));
    //alert(id); //outputs #ShowThisDiv 
    $(".store .shogun-accordion-wrapper #tab-0 .shogun-accordion-body").addClass( "shogun-accordion-active" );
    $('html, body').animate({
      scrollTop: $(".store .shogun-accordion-wrapper #tab-0 .shogun-accordion-body").offset().top
    }, 700);
  }

  if (acc == 'tab-1') {
    var id = url.substring(url.lastIndexOf('#'));
    //alert(id); //outputs #ShowThisDiv 
    $(".store .shogun-accordion-wrapper #tab-0 .shogun-accordion-body").removeClass( "shogun-accordion-active" );
    $(".store .shogun-accordion-wrapper #tab-1 .shogun-accordion-body").addClass( "shogun-accordion-active" );
    $('html, body').animate({
      scrollTop: $(".store .shogun-accordion-wrapper #tab-1 .shogun-accordion-body").offset().top
    }, 100);
  }

  if (acc == 'tab-4') {
    var id = url.substring(url.lastIndexOf('#'));
    //alert(id); //outputs #ShowThisDiv
    $(".store .shogun-accordion-wrapper #tab-0 .shogun-accordion-body").removeClass( "shogun-accordion-active" );
    $(".store .shogun-accordion-wrapper #tab-4 .shogun-accordion-body").addClass( "shogun-accordion-active" );
    $('html, body').animate({
      scrollTop: $(".store .shogun-accordion-wrapper #tab-4 .shogun-accordion-body").offset().top
    }, 300);
  }

  //Wireless Page BV reviews
  var url = window.location.href;
  var wirelesss = url.substring(url.lastIndexOf('/') + 1);
  //console.log(ref);
  if(wirelesss=='wireless-security-systems'){
    //alert('wirelesss');
    //$('.guard .inner_content .wired-category-row .wired-category-col:nth-child(2) .wired-product-reviews').attr("data-bv-product-id", "4501588344898"); 
    //$('.phoenix .inner_content .wired-category-row .wired-category-col:nth-child(3) .wired-product-reviews').attr("data-bv-product-id", "4630482387010"); 

  }

  //Slick For Realted Products --- CART UPSELLS ACCESSORIES
  var numItems = $(".combine-accessories .wired-category-col").length;
  //console.log(numItems);
  if ( $('.combine-accessories .wired-category-col').length >= 3 ) {
    $('.combine-accessories').slick({
      slide: 'div.wired-category-col',
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "slick"     

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: true
          }
        },{
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: true
          }
        }
      ]
    });

  }

  //TAX notes alert for text area.
  $(".tax-button").click(function(event){
    var comment = $.trim($(".tax-notes").val());
    //alert(text);
    if( comment  == "" ){
      $('.tax textarea[required]').css("border-color", "red");
      $('.tax textarea').focus();
    }
    else{       
      var textareaText = $.trim($(".tax .tax-notes").val()); 
      var insertText = 'Tax-ID:';
      $('.tax-notes').empty().val(insertText + textareaText);
      //alert(test);         
    }
  });

  $(".tax-notes").keypress(function (e) {
    var keyCode = e.keyCode || e.which;
    $("#lblError").html("");
    //Regex for Valid Characters i.e. Alphabets and Numbers.
    var regex = /^[0-9]+$/;

    //Validate TextBox value against the Regex.
    var isValid = regex.test(String.fromCharCode(keyCode));
    if (!isValid) {
      $("#lblError").html("This field only accepts numbers.");
    }
    return isValid;
  });

  // tax notes alert message on click pop up
  $(".tax-alert").click(function(event){
    //alert('Tax');
    $(".ssn").show(); 
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27)  {
        $("body").removeClass( "no-scroll" );
        $(".ssn").hide();
      }
    });  
    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".ssn").hide();
    }); 

    // CLOSE THE POPUP
    $('body').on('click','.product-overlay.ssn', function(e) {
      $(".ssn").hide();
      e.stopPropagation();
    });

  });

  // Warranty pop up functions
  var url = window.location.href;
  var cart = url.substring(url.lastIndexOf('/') + 1);
  //console.log(c);
  if(cart=='cart'){
    $('.2-Cameras').on('click', function() {
      // CART ALert POP UP
      //alert('IN');
      //alert($(this).attr("data-value"));
      $("#plan").html($(this).attr("data-value"));
      $(".warranty-popup").show();    
      $('.main-header-wrapper').addClass('zindex1');
      if ($('.product-overlay').length > 0){
        //$("body").addClass( "no-scroll" );
      }       
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $('.product-overlay').remove();
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup").hide();
          $(".eti-simple-container.2-Cameras").focus();
          //window.location.reload();	
        }
      });

      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup").hide();
        $(".eti-simple-container.2-Cameras").focus();
        //window.location.reload();	
      });  

      // CLOSE THE POPUP
      //$('body').on('click','.product-overlay.warranty-popup', function(e) {
      //$(".warranty-popup").hide();
      //e.stopPropagation();
      //});

    });

    $('.3-Cameras').on('click', function() {
      //alert($(this).attr("data-value"));
      $("#plan1").html($(this).attr("data-value"));
      $(".warranty-popup1").show();
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          //$('.product-overlay').remove();
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup1").hide();
          $(".eti-simple-container.3-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup1").hide();
        $(".eti-simple-container.3-Cameras").focus();
        //window.location.reload();	
      });

    });

    $('.4-Cameras').on('click', function() {
      //alert($(this).attr("data-value"));
      $("#plan4").html($(this).attr("data-value"));
      $(".warranty-popup4").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup4").hide();
          $(".eti-simple-container.4-Cameras").focus();
          // window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup4").hide();
        $(".eti-simple-container.4-Cameras").focus();
        //window.location.reload();	
      });

    });

    $('.41-Cameras').on('click', function() {
      //alert($(this).attr("data-value"));
      $("#plan41").html($(this).attr("data-value"));
      $(".warranty-popup41").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup41").hide();
          $(".eti-simple-container.41-Cameras").focus();
          // window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup41").hide();
        $(".eti-simple-container.41-Cameras").focus();
        //window.location.reload();	
      });

    });   

    $('.V4Cameras').on('click', function() {
      //alert($(this).attr("data-value"));
      $("#planV4").html($(this).attr("data-value"));
      $(".warranty-popupV4").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popupV4").hide();
          $(".eti-simple-container.V4Cameras").focus();
          // window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popupV4").hide();
        $(".eti-simple-container.V4Cameras").focus();
        //window.location.reload();	
      });

    });    


    $('.4k2TBCameras').on('click', function() {
      //alert($(this).attr("data-value"));
      $("#plan4K2TB").html($(this).attr("data-value"));
      $(".warranty-popup4K2TB").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup4K2TB").hide();
          $(".eti-simple-container.4k2TBCameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup4K2TB").hide();
        $(".eti-simple-container.4k2TBCameras").focus();
        //window.location.reload();	
      });

    });

    $('.5-Cameras').on('click', function() {
      //alert($(this).attr("data-value"));
      $("#plan5").html($(this).attr("data-value"));
      $(".warranty-popup5").show();
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup5").hide();
          $(".eti-simple-container.5-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup5").hide();
        $(".eti-simple-container.5-Cameras").focus();
        //window.location.reload();	
      });

    });


    $('.V5Cameras').on('click', function() {
      //alert($(this).attr("data-value"));
      $("#planV5").html($(this).attr("data-value"));
      $(".warranty-popupV5").show();
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popupV5").hide();
          $(".eti-simple-container.V5Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popupV5").hide();
        $(".eti-simple-container.V5Cameras").focus();
        //window.location.reload();	
      });

    });   


    $('.6-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan6").html($(this).attr("data-value"));
      $(".warranty-popup6").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup6").hide();
          $(".eti-simple-container.6-Cameras").focus();	
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup6").hide();
        $(".eti-simple-container.6-Cameras").focus();	
        //window.location.reload();	
      });

    });

    $('.V6Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#planV6").html($(this).attr("data-value"));
      $(".warranty-popupV6").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popupV6").hide();
          $(".eti-simple-container.V6Cameras").focus();	
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popupV6").hide();
        $(".eti-simple-container.V6Cameras").focus();	
        //window.location.reload();	
      });

    });  


    $('.7-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan7").html($(this).attr("data-value"));
      $(".warranty-popup7").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup7").hide();
          $(".eti-simple-container.7-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup7").hide();
        $(".eti-simple-container.7-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.V7Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#planV7").html($(this).attr("data-value"));
      $(".warranty-popupV7").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popupV7").hide();
          $(".eti-simple-container.V7Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popupV7").hide();
        $(".eti-simple-container.V7Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.8-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan8").html($(this).attr("data-value"));
      $(".warranty-popup8").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup8").hide();
          $(".eti-simple-container.8-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup8").hide();
        $(".eti-simple-container.8-Cameras").focus();
        //window.location.reload();	
      });

    });

    $('.V8Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#planV8").html($(this).attr("data-value"));
      $(".warranty-popupV8").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popupV8").hide();
          $(".eti-simple-container.V8Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popupV8").hide();
        $(".eti-simple-container.V8Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.82TB-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan82TB").html($(this).attr("data-value"));
      $(".warranty-popup82TB").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27) {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup82TB").hide();
          $(".eti-simple-container.82TB-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup82TB").hide();
        $(".eti-simple-container.82TB-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.9-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan9").html($(this).attr("data-value"));
      $(".warranty-popup9").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup9").hide();
          $(".eti-simple-container.9-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup9").hide();
        $(".eti-simple-container.9-Cameras").focus();
        //window.location.reload();	
      });

    });

    $('.10-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan10").html($(this).attr("data-value"));
      $(".warranty-popup10").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup10").hide();
          $(".eti-simple-container.10-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup10").hide();
        $(".eti-simple-container.10-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.11-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan11").html($(this).attr("data-value"));
      $(".warranty-popup11").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup11").hide();
          $(".eti-simple-container.11-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup11").hide();
        $(".eti-simple-container.11-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.12-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan12").html($(this).attr("data-value"));
      $(".warranty-popup12").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup12").hide();
          $(".eti-simple-container.12-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup12").hide();
        $(".eti-simple-container.12-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.13-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan13").html($(this).attr("data-value"));
      $(".warranty-popup13").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup13").hide();
          $(".eti-simple-container.13-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup13").hide();
        $(".eti-simple-container.13-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.14-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan14").html($(this).attr("data-value"));
      $(".warranty-popup14").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup14").hide();
          $(".eti-simple-container.14-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup14").hide();
        $(".eti-simple-container.14-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.15-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan15").html($(this).attr("data-value"));
      $(".warranty-popup15").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup15").hide();
          $(".eti-simple-container.15-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup15").hide();
        $(".eti-simple-container.15-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.16-Cameras').on('click', function() {   
      // alert($(this).attr("data-value"));
      $("#plan16").html($(this).attr("data-value"));
      $(".warranty-popup16").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup16").hide();
          $(".eti-simple-container.16-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup16").hide();
        $(".eti-simple-container.16-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.17-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#guard1Pack").html($(this).attr("data-value"));
      $(".warranty-popup17").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup17").hide();
          $(".eti-simple-container.17-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup17").hide();
        $(".eti-simple-container.17-Cameras").focus();
        //window.location.reload();	
      });

    }); 

    $('.18-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#guard2Pack").html($(this).attr("data-value"));
      $(".warranty-popup18").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup18").hide();
          $(".eti-simple-container.18-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup18").hide();
        $(".eti-simple-container.18-Cameras").focus();
        //window.location.reload();	
      });  
    });  

    $('.19-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#guard3Pack").html($(this).attr("data-value"));
      $(".warranty-popup19").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup19").hide();
          $(".eti-simple-container.19-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup19").hide();
        $(".eti-simple-container.19-Cameras").focus();
        //window.location.reload();	
      });  
    }); 

    $('.20-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#phoenix2cam").html($(this).attr("data-value"));
      $(".warranty-popup20").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup20").hide();
          $(".eti-simple-container.20-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup20").hide();
        $(".eti-simple-container.20-Cameras").focus();
        //window.location.reload();	
      });  
    });   

    $('.21-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#phoenix3cam").html($(this).attr("data-value"));
      $(".warranty-popup21").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup21").hide();
          $(".eti-simple-container.21-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup21").hide();
        $(".eti-simple-container.21-Cameras").focus();
        //window.location.reload();	
      });  
    }); 

    $('.22-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#phoenix4cam").html($(this).attr("data-value"));
      $(".warranty-popup22").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup22").hide();
          $(".eti-simple-container.22-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup22").hide();
        $(".eti-simple-container.22-Cameras").focus();
        //window.location.reload();	
      });  
    }); 

    $('.23-Cameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#guard4Pack").html($(this).attr("data-value"));
      $(".warranty-guard4Pack").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-guard4Pack").hide();
          $(".eti-simple-container.23-Cameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-guard4Pack").hide();
        $(".eti-simple-container.23-Cameras").focus();
        //window.location.reload();	
      });  
    });   

    $('.RefurbCameras').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan23").html($(this).attr("data-value"));
      $(".warranty-popup23").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup23").hide();
          $(".eti-simple-container.RefurbCameras").focus();
          //window.location.reload();	
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup23").hide();
        $(".eti-simple-container.RefurbCameras").focus();
        //window.location.reload();	
      });  
    });

    $('.RefurbCameras1').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan24").html($(this).attr("data-value"));
      $(".warranty-popup24").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup24").hide();
          $(".eti-simple-container.RefurbCameras1").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup24").hide();
        $(".eti-simple-container.RefurbCameras1").focus();
      });  
    });  

    $('.RefurbCameras2').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan25").html($(this).attr("data-value"));
      $(".warranty-popup25").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup25").hide();
          $(".eti-simple-container.RefurbCameras2").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup25").hide();
        $(".eti-simple-container.RefurbCameras2").focus();
      });  
    });  

    $('.RefurbCameras3').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan26").html($(this).attr("data-value"));
      $(".warranty-popup26").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup26").hide();
          $(".eti-simple-container.RefurbCameras3").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup26").hide();
        $(".eti-simple-container.RefurbCameras3").focus();
      });  
    });  

    $('.RefurbCameras4').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan27").html($(this).attr("data-value"));
      $(".warranty-popup27").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup27").hide();
          $(".eti-simple-container.RefurbCameras4").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup27").hide();
        $(".eti-simple-container.RefurbCameras4").focus();
      });  
    });  

    $('.RefurbCameras5').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan28").html($(this).attr("data-value"));
      $(".warranty-popup28").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup28").hide();
          $(".eti-simple-container.RefurbCameras5").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup28").hide();
        $(".eti-simple-container.RefurbCameras5").focus();
      });  
    });  

    $('.RefurbCameras6').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan29").html($(this).attr("data-value"));
      $(".warranty-popup29").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup29").hide();
          $(".eti-simple-container.RefurbCameras6").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup29").hide();
        $(".eti-simple-container.RefurbCameras6").focus();
      });  
    });  

    $('.RefurbCameras7').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan30").html($(this).attr("data-value"));
      $(".warranty-popup30").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup30").hide();
          $(".eti-simple-container.RefurbCameras7").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup30").hide();
        $(".eti-simple-container.RefurbCameras7").focus();
      });  
    });  

    $('.RefurbCameras8').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan31").html($(this).attr("data-value"));
      $(".warranty-popup31").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup31").hide();
          $(".eti-simple-container.RefurbCameras8").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup31").hide();
        $(".eti-simple-container.RefurbCameras8").focus();
      });  
    });   

    $('.RefurbCameras9').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan32").html($(this).attr("data-value"));
      $(".warranty-popup32").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup32").hide();
          $(".eti-simple-container.RefurbCameras9").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup32").hide();
        $(".eti-simple-container.RefurbCameras9").focus();
      });  
    });     
    $('.RefurbCameras10').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan33").html($(this).attr("data-value"));
      $(".warranty-popup33").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".warranty-popup33").hide();
          $(".eti-simple-container.RefurbCameras10").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".warranty-popup33").hide();
        $(".eti-simple-container.RefurbCameras10").focus();
      });  
    });

    //Guard Pro Onclick Function
    $('.GuardPro1').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan34").html($(this).attr("data-value"));
      $(".GuardPropopup1").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".GuardPropopup1").hide();
          $(".eti-simple-container.GuardPro1").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".GuardPropopup1").hide();
        $(".eti-simple-container.GuardPro1").focus();
      });  
    });
    $('.GuardPro2').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan35").html($(this).attr("data-value"));
      $(".GuardPropopup2").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".GuardPropopup2").hide();
          $(".eti-simple-container.GuardPro2").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".GuardPropopup2").hide();
        $(".eti-simple-container.GuardPro2").focus();
      });  
    });
    $('.GuardPro3').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan36").html($(this).attr("data-value"));
      $(".GuardPropopup3").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".GuardPropopup3").hide();
          $(".eti-simple-container.GuardPro3").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".GuardPropopup3").hide();
        $(".eti-simple-container.GuardPro3").focus();
      });  
    });

    $('.GuardPro4').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan37").html($(this).attr("data-value"));
      $(".GuardPropopup4").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".GuardPropopup4").hide();
          $(".eti-simple-container.GuardPro4").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".GuardPropopup4").hide();
        $(".eti-simple-container.GuardPro4").focus();
      });  
    });

    $('.Vision').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan38").html($(this).attr("data-value"));
      $(".Visionpopup").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".Visionpopup").hide();
          $(".eti-simple-container.Vision").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".Visionpopup").hide();
        $(".eti-simple-container.Vision").focus();
      });  
    });

    $('.Apex4cam').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan39").html($(this).attr("data-value"));
      $(".Apex4campopup").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".Apex4campopup").hide();
          $(".eti-simple-container.Apex4cam").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".Apex4campopup").hide();
        $(".eti-simple-container.Apex4cam").focus();
      });  
    });

    $('.sent4cam').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#plan40").html($(this).attr("data-value"));
      $(".sent4campopup").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".sent4campopup").hide();
          $(".eti-simple-container.sent4cam").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".sent4campopup").hide();
        $(".eti-simple-container.sent4cam").focus();
      });  
    });

    $('.sent8cam').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#sent-title").html($(this).attr("data-value"));
      $(".sent8campopup").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".sent8campopup").hide();
          $(".eti-simple-container.sent8cam").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".sent8campopup").hide();
        $(".eti-simple-container.sent8cam").focus();
      });  
    });

$('.sent16cam').on('click', function() {   
      //alert($(this).attr("data-value"));
      $("#sent-title").html($(this).attr("data-value"));
      $(".sent16campopup").show(); 
      $('.main-header-wrapper').addClass('zindex1');
      $(document).on('keyup',function(e) {
        if (e.keyCode == 27)  {
          $("body").removeClass( "no-scroll" );
          $(".sent16campopup").hide();
          $(".eti-simple-container.sent16cam").focus();
        }
      });  
      // CLOSE AND REMOVE ON CLICK
      $('body').on('click','.close', function() {
        $("body").removeClass( "no-scroll" );
        $(".sent16campopup").hide();
        $(".eti-simple-container.sent16cam").focus();
      });  
    });

    //Warranty add to cart Function         
    $('.warranty-shop.one').on('click', function(e) {   
      //alert('ONE');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty = $("#plan").text();
      //alert(warranty); 
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.two').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty1 = $("#plan1").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty1}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.threeOne').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty3_1 = $("#plan41").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty3_1}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });  

    $('.warranty-shop.three').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty3 = $("#plan4").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty3}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.three1').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty31 = $("#planV4").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty31}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });    


    $('.warranty-shop.four').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty4 = $("#plan4K2TB").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty4}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });    

    $('.warranty-shop.five').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty5 = $("#plan5").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty5}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.five1').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warrantyV5 = $("#planV5").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warrantyV5}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });   


    $('.warranty-shop.six').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty6 = $("#plan6").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty6}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.six1').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warrantyV6 = $("#planV6").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warrantyV6}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });   



    $('.warranty-shop.seven').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty7 = $("#plan7").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty7}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.seven1').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warrantyV7 = $("#planV7").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warrantyV7}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });  



    $('.warranty-shop.eight').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty8 = $("#plan8").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty8}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.eight1').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warrantyV8 = $("#planV8").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warrantyV8}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.eight2TB').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty82TB = $("#plan82TB").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty82TB}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });  

    $('.warranty-shop.nine').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty9 = $("#plan9").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty9}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });  

    $('.warranty-shop.ten').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty10 = $("#plan10").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty10}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.eleven').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty11 = $("#plan11").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty11}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.twelve').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty12 = $("#plan12").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty12}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.thirteen').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty13 = $("#plan13").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty13}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });   

    $('.warranty-shop.fourteen').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty14 = $("#plan14").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty14}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });   

    $('.warranty-shop.fivteen').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty15 = $("#plan15").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty15}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });   

    $('.warranty-shop.sixteen').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty16 = $("#plan16").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty16}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });  

    $('.warranty-shop.seventeen').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var guard1Pack = $("#guard1Pack").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : guard1Pack}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });  

    $('.warranty-shop.eighteen').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var guard2Pack = $("#guard2Pack").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : guard2Pack}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.nineteen').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var guard3Pack = $("#guard3Pack").text();
      //alert(warranty19);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : guard3Pack}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.guard4Pack').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var guard4Pack = $("#guard4Pack").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : guard4Pack}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 


    $('.warranty-shop.twenty').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var phoenix2cam = $("#phoenix2cam").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : phoenix2cam}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });   

    $('.warranty-shop.twenteenone').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var phoenix3cam = $("#phoenix3cam").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : phoenix3cam}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.twenteentwo').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var phoenix4cam = $("#phoenix4cam").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : phoenix4cam}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    }); 

    $('.warranty-shop.refurbone').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty23 = $("#plan23").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty23}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurbtwo').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty24 = $("#plan24").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty24}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });  

    $('.warranty-shop.refurbthree').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty25 = $("#plan25").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty25}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurbfour').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty26 = $("#plan26").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty26}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurbfive').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty27 = $("#plan27").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty27}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurbsix').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty28 = $("#plan28").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty28}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurbseven').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty29 = $("#plan29").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty29}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurbeight').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty30 = $("#plan30").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty30}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurbnine').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty31 = $("#plan31").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty31}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurb10').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty32 = $("#plan32").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty32}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.refurb11').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty33 = $("#plan33").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty33}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.guardPro1').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty34 = $("#plan34").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty34}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });
    $('.warranty-shop.guardPro2').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty35 = $("#plan35").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty35}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });
    $('.warranty-shop.guardPro3').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty36 = $("#plan36").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty36}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });
    $('.warranty-shop.guardPro4').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty37 = $("#plan37").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty37}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });

    $('.warranty-shop.vision').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty38 = $("#plan38").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty38}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });
    $('.warranty-shop.apex4').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty39 = $("#plan39").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty39}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });
    $('.warranty-shop.sent4').on('click', function(e) {   
      //alert('two');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty40 = $("#plan40").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty40}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });
    $('.warranty-shop.sent8').on('click', function(e) {   
      //alert('two');
      localStorage.setItem('popup-enabled', 'Hamad Yes');
      var obj=$(this);
      var ID = $(this).attr("warranty_id");
      var warranty41 = $("#sent-title").text();
      // alert(warranty1);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID,
          properties: { 'Product' : warranty41}
        },
        dataType: 'json', 
        success: function (cart) {  
          window.location.reload(); 	
        } 

      });     
    });
if(localStorage.getItem('popup-enabled'))
         // $("#accessories-popup").hide();
         $("body").addClass( "scroll" );
          console.log("my name is hamad")



    $(".warrantyBox .centered .row .column:nth-child(1) h2").text("2 Years");
    $(".warrantyBox .centered .row .column:nth-child(2) h2").text("3 Years");
    $('.warrantyBox .centered .row .column:nth-child(1) .warranty-shop').after( '<ul class="inlineList"><li>2 Years Worry-Free</li><li>Advanced Replacements</li><li>Product Defects</li></ul>' );
    $('.warrantyBox .centered .row .column:nth-child(2) .warranty-shop').after( '<ul class="inlineList"><li>3 Years Worry-Free</li><li>Advanced Replacements</li><li>Product Defects</li><li>Free Return Shipping</li></ul>' );

  }

  //Testimonial Slick
  if ($('#testimonial-section .list-item').length >= 3 ) {
    $('#testimonial-section .module-body .list').slick({
      slide: 'div.list-item',
      speed: 500,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"     

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        }
      ]
    });

  }

  //HOME Page Defender reviews
  if ( $('#shopify-section-1587677518831 .list-item').length >= 3 ) {
    $('#shopify-section-1587677518831 .module-body .list').slick({
      slide: 'div.list-item',
      speed: 600,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 6000,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"     

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }

  // Partner logo SLick   
  if( $('#partner-section .list-item').length >= 3 ) {
    $('#partner-section .module-body .list').slick({
      slide: 'div.list-item',
      speed: 700,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 7000,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"     

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: true
          }
        },
        {
          breakpoint: 1075,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          }
        }
      ]
    });

  }

  //OpenTab Accordion tabs
  var $OpenTab = $('.refurbished #Open-box .title_tab');
  $('#Open-box .Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  $('#Open-box .Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $OpenTab.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
    }
  });


  // Accordion tabs
  var $titleTab = $('.extended-warranties .title_tab');
  //$('.Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  //$('.Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
  $titleTab.on('click', function(e) {
    e.preventDefault();
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
      $(this).next().find('p').addClass('show');         	
    }
  });

  //Tool tip 
  var targets = $( '[rel~=tooltip]' ),
      target	= false,
      tooltip = false,
      title	= false;

  targets.bind( 'mouseenter', function()
               {
    target	= $( this );
    tip		= target.attr( 'title' );
    tooltip	= $( '<div id="tooltip"></div>' );

    if( !tip || tip == '' )
      return false;

    target.removeAttr( 'title' );
    tooltip.css( 'opacity', 0 )
    .html( tip )
    .appendTo( 'body' );

    var init_tooltip = function()
    {
      if( $( window ).width() < tooltip.outerWidth() * 1.5 )
        tooltip.css( 'max-width', $( window ).width() / 2 );
      else
        tooltip.css( 'max-width', 340 );

      var pos_left = target.offset().left + ( target.outerWidth() / 2 ) - ( tooltip.outerWidth() / 2 ),
          pos_top	 = target.offset().top - tooltip.outerHeight() - 20;

      if( pos_left < 0 )
      {
        pos_left = target.offset().left + target.outerWidth() / 2 - 20;
        tooltip.addClass( 'left' );
      }
      else
        tooltip.removeClass( 'left' );

      if( pos_left + tooltip.outerWidth() > $( window ).width() )
      {
        pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
        tooltip.addClass( 'right' );
      }
      else
        tooltip.removeClass( 'right' );

      if( pos_top < 0 )
      {
        var pos_top	 = target.offset().top + target.outerHeight();
        tooltip.addClass( 'top' );
      }
      else
        tooltip.removeClass( 'top' );

      tooltip.css( { left: pos_left, top: pos_top } )
      .animate( { top: '+=10', opacity: 1 }, 50 );
    };

    init_tooltip();
    $( window ).resize( init_tooltip );

    var remove_tooltip = function()
    {
      tooltip.animate( { top: '-=10', opacity: 0 }, 50, function()
                      {
        $( this ).remove();
      });

      target.attr( 'title', tip );
    };

    target.bind( 'mouseleave', remove_tooltip );
    tooltip.bind( 'click', remove_tooltip );
  });

  // Extended warranties slick
  if ( $('#extended-warranties .list-item').length >= 3 ) {
    $('#extended-warranties .module-body .list').slick({
      slide: 'div.list-item',
      speed: 300,
      slidesToShow: 3,
      autoplay: false,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"     

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
            initialSlide:2
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true
          }
        }
      ]
    });

  } 

  //Free product Addon in the  CART 
  var Freeproductstart = new Date("April 01, 2022 00:00:00 EDT");
  var Freeproductend = new Date("April 03, 2022 23:59:59 EDT");   
  if (currentTime.getTime() > Freeproductstart.getTime() && currentTime.getTime() <= Freeproductend.getTime())
  {
    $("#freeProduct-add-on").css("display","block");
  }

  //2 Year warranty Pop up in the  CART 
  var Warrantystart = new Date("April 26, 2021 00:00:00 EDT");
  var Warrantyend = new Date("April 27, 2021 23:59:59 EDT");   
  if (currentTime.getTime() > Warrantystart.getTime() && currentTime.getTime() <= Warrantyend.getTime())
  {
    $("#warranty-popup").css("display","block");
  }

  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });

  //Tabs for Custome Product pages
  $('.custom-product ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.custom-product ul.tabs li').removeClass('current');
    $('.custom-product .tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

  //fixed header for Custom Product page
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 900) {
      $('.custom-product ul.tabs').addClass('fixed-header');       
    }
    else {
      $('.custom-product ul.tabs').removeClass('fixed-header');        
    }
  }); 

  // onclick scroll to page up for products
  $('.tabs .tab-link').on('click', function(e) {
    //alert('IN');
    e.preventDefault();            
    if(window.outerWidth <=767) {
      //alert('mobile');
      $('html, body').animate({
        scrollTop: $(".tab-content.current").offset().top
      }, 1000);
    } else {
      $('html, body').animate({
        scrollTop: $(".tab-content.current").offset().top
      }, 700);
    }
  });  

  //Products Image slider for Desktop
  $('.custom-product .product-mobile').hide(); 
  $('.custom-product .slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.custom-product .slider-nav'
  });
  $('.custom-product .slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.custom-product .slider-for',
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-up"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-down"></i></button>',
    focusOnSelect: true,
    verticalSwiping: true,
    vertical: true
  });
//Products Image slider for EB Desktop
  $('.custom-product .product-mobile').hide(); 
  $('.custom-product .EB-slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.custom-product .EB-slider-nav'
  });
  $('.custom-product .EB-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.custom-product .EB-slider-for',
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-up"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-down"></i></button>',
    focusOnSelect: true,
    verticalSwiping: true,
    vertical: false
  });
  $('a[data-slide]').click(function(e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    $('.custom-product .slider-nav').slick('slickGoTo', slideno - 1);
  }); 

  var windowWidth = $(window).width();
  if(windowWidth <= 767) { 
    $('.custom-product .desktop-show').hide();
    $('.custom-product .product-mobile').show();
    $('.custom-product .product-mobile .image-slider .slider').slick({
      slide: 'div.thumbnail-image',
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"    

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true
          }
        }
      ]
    });

  }

  //Onclick add warranty Selected 
   $('.pd_warranty.warr a').click(function(e){
   // $('.pd_warranty.warr a').removeClass('selected');
    $('.pd_warranty.warr a').not(this).removeClass('selected');
       $(this).toggleClass('selected');  
     var has_selected = $('.pd_warranty.warr a').hasClass('selected');
     if(has_selected == false){
       $('.pd_warranty.warr .noPadLR a').addClass('selected');
     }
  });  
  
  //Onclick add accessories Selected 
  $('.pd_warranty.acc .noPadding.acc:nth-child(3) a').click(function(e){
    $(this).toggleClass('selected1');
  });
  $('.pd_warranty.acc .noPadding.acc:nth-child(4) a').click(function(e){
    $(this).toggleClass('selected2');
  });
  $('.pd_warranty.acc .noPadding.acc:nth-child(5) a').click(function(e){
    $(this).toggleClass('selected3');
  });

  $('.thumbnail-image .product-gallery-image-img').click(function(e){
    //$('.product-image-zoom').addClass('active');
  });  

  $(".product-big-image img.product-image").click(function () {
    var $src = $(this).attr("src");
    $(".image-view").show();
    $(".Box img").attr("src", $src);
    $('.main-header-wrapper').addClass('zindex1');
  });

  $("span, .overlay").click(function () {
    $(".image-view").hide();
    $('.main-header-wrapper').removeClass('zindex1');
  });  


  //Onclick get Product and Warranty selected ID 
   $('#product-add').on('click', function() {
    //alert("Product testing...");
    var wtyProductId = $('.pd_warranty.warr a.selected').attr('warranty_id');
    //alert(wtyProductId);

    var ProductTitle = $("#ProductTitle").text();
    //alert(ProductTitle);   

    var accProductId1 = $('.pd_warranty.acc a.selected1').attr('access_id');

    var accProductId2 = $('.pd_warranty.acc a.selected2').attr('access_id');

    var accProductId3 = $('.pd_warranty.acc a.selected3').attr('access_id');
    // console.log(accProductId);  

    //Get Product ID
    var ProductId = $("#ProductId").val();
    //alert(ProductId);

    // 1 have values
    if((ProductId != null) && (wtyProductId =='NULL')  && (typeof accProductId1 == "undefined") && (typeof accProductId2 == "undefined") && (typeof accProductId3 == "undefined")){ 
      //alert('Product');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ProductId
        },
        dataType: 'json', 
        success: function (cart) {   
          window.location.href ="/cart";
        }           

      });                    
    }

    //IF warranty ID has value insert the Product
    if((ProductId != null) && (wtyProductId !='NULL')  && (typeof accProductId1 == "undefined") && (typeof accProductId2 == "undefined") && (typeof accProductId3 == "undefined")) {
      //alert('Warranty');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: wtyProductId,
          properties: { 'Product' : ProductTitle}
        },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }

    
// if accessories are 1
  if((ProductId != null) && (wtyProductId =='NULL') && (typeof accProductId1 != "undefined") && (typeof accProductId2 == "undefined") && (typeof accProductId3 == "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId1
        },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }
    
// if accessories is 1 and warranty is 1
    
  if((ProductId != null) && (wtyProductId !='NULL') && (typeof accProductId1 != "undefined") && (typeof accProductId2 == "undefined") && (typeof accProductId3 == "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: wtyProductId
        },
         dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: accProductId1
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }
      });
  }
    
    // if accessories is 2
  if((ProductId != null) && (wtyProductId =='NULL') && (typeof accProductId1 == "undefined")  && (typeof accProductId2 != "undefined") && (typeof accProductId3 == "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId2
        },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }

// if accessories is 2 and warranty is 1
    
  if((ProductId != null) && (wtyProductId !='NULL') && (typeof accProductId1 == "undefined") && (typeof accProductId2 != "undefined") && (typeof accProductId3 == "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: wtyProductId
        },
         dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: accProductId2
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }
      });
  }
    
    // if accessories is 3
  if((ProductId != null) && (wtyProductId =='NULL') && (typeof accProductId1 == "undefined")  && (typeof accProductId2 == "undefined") && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId3
        },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }


// if accessories selected is 3 and warranty is 1
    
  if((ProductId != null) && (wtyProductId !='NULL') && (typeof accProductId1 == "undefined") && (typeof accProductId2 == "undefined") && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: wtyProductId
        },
         dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: accProductId3
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }
      });
  }
    
// if first 2 accessories are selected
  if((ProductId != null) && (wtyProductId =='NULL') && (typeof accProductId1 != "undefined")  && (typeof accProductId2 != "undefined") && (typeof accProductId3 == "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId1
        },
         dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId2 // Replace with the second product's ID
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }
          }); 
        }           
      }); 
    }
      });
  }

    // if first 2 accessories are selected and warranty is also selected
  if((ProductId != null) && (wtyProductId !='NULL') && (typeof accProductId1 != "undefined")  && (typeof accProductId2 != "undefined") && (typeof accProductId3 == "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId1
        },
         dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId2 // Replace with the second product's ID
            },
           dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: wtyProductId
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }
          }); 
        }           
      }); 
    }
      });
  }
      });
  }

  // if 2 and 3 accessories are selected
  if((ProductId != null) && (wtyProductId =='NULL') && (typeof accProductId1 == "undefined") && (typeof accProductId2 != "undefined")  && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId2
        },
         dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId3 // Replace with the second product's ID
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }
          }); 
        }           
      }); 
    }
      });
  }

      // if 2 and 3 accessories are selected and warranty is also selected
  if((ProductId != null) && (wtyProductId !='NULL') && (typeof accProductId1 == "undefined") && (typeof accProductId2 != "undefined")  && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId2
        },
         dataType: 'json',
    success: function (cart) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId3 // Replace with the second product's ID
            },
          dataType: 'json',
    success: function (cart) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: wtyProductId // Replace with the second product's ID
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }
          }); 
        }           
      }); 
    }
      });
  }
      });
  }

 // if 1 and 3 accessories are selected
  if((ProductId != null) && (wtyProductId =='NULL') && (typeof accProductId1 != "undefined") && (typeof accProductId2 == "undefined")  && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId1
        },
         dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId3 // Replace with the second product's ID
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }
          }); 
        }           
      }); 
    }
      });
  }


      // if 1 and 3 accessories are selected and warranty is also selected
   if((ProductId != null) && (wtyProductId !='NULL') && (typeof accProductId1 != "undefined") && (typeof accProductId2 == "undefined")  && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId1
        },
         dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId3 // Replace with the second product's ID
            },
            dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: wtyProductId // Replace with the second product's ID
            },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }
          }); 
        }           
      }); 
    }
      });
  }
      });
   }
    
        // if all accessories are selected
     if((ProductId != null) && (wtyProductId =='NULL') && (typeof accProductId1 != "undefined") && (typeof accProductId2 != "undefined") && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
     $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
        quantity: 1,
        id: accProductId1 // Replace with the first product's ID
    },
    dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId2 // Replace with the second product's ID
            },
            dataType: 'json',
            success: function (cart) {
                // Second product added successfully
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: accProductId3 // Replace with the third product's ID
                    },
                   dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
                    dataType: 'json',
                    success: function (cart) {
                        // Third product added successfully
                        window.location.href = "/cart";
                    }
                });
            }
        });
    }
});
    }
     });
    }

 // if all accessories are selected and also the warranty is selected
     if((ProductId != null) && (wtyProductId !='NULL') && (typeof accProductId1 != "undefined") && (typeof accProductId2 != "undefined") && (typeof accProductId3 != "undefined")) {
      //alert('Accessories');
     $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
        quantity: 1,
        id: accProductId1 // Replace with the first product's ID
    },
    dataType: 'json',
    success: function (cart) {
        // First product added successfully
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: accProductId2 // Replace with the second product's ID
            },
            dataType: 'json',
            success: function (cart) {
                // Second product added successfully
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: accProductId3 // Replace with the third product's ID
                    },
                  dataType: 'json',
            success: function (cart) {
                // Second product added successfully
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: wtyProductId // Replace with the third product's ID
                    },
                   dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
                    dataType: 'json',
                    success: function (cart) {
                        // Third product added successfully
                        window.location.href = "/cart";
                    }
                });
            }
        });
    }
});
    }
     });
    }
     });
     }
    
    //When all 3 have values
    // if((ProductId!='') && (wtyProductId!='NULL') && (accProductId1 != null) && (accProductId2 != null) && (accProductId3 != null)) {
    //   //alert('3');
    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: {
    //       quantity: 1,
    //       id: wtyProductId,
    //       properties: { 'Product' : ProductTitle}
    //     },
    //     dataType: 'json', 
    //     success: function (cart) {  
    //       $.ajax({
    //         type: 'POST',
    //         url: '/cart/add.js',
    //         data: {
    //           quantity: 1,
    //           id: accProductId1
    //         },
    //         dataType: 'json', 
    //         success: function (cart) {
    //           $.ajax({
    //             type: 'POST',
    //             url: '/cart/add.js',
    //             data: {
    //               quantity: 1,
    //               id: ProductId
    //             },
    //             dataType: 'json', 
    //             success: function (cart) {   
    //               window.location.href ="/cart";
    //             }           
    //           }); 
    //         }           
    //       }); 
    //     }           
    //   }); 
    // }

  });
  //$('iframe').attr('id','video');
  // $('#productVideo').on('click', function(ev) {
  //   //var PopupEmbedLink = $(".youtube_video")[0].src += "&autoplay=1";
  //   var PopupEmbedLink = $(".youtube_video")[0].src;

  //   $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+PopupEmbedLink+'" allowfullscreen></iframe></div></div>');

  //   if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
  //     setTimeout(function() {
  //       $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
  //     }, 600);
  //   }

  //   $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
  //     $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
  //   });

  //   ev.preventDefault();
  // }); 


  //Product Block slider	 
  //if(index== US ){
    //if(window.outerWidth <=767) {
      //alert('mobile');  
      /* $('.product-block').slick({
            slide: 'div.list-item',
            speed: 300,
            slidesToShow: 3,
            autoplay: true,
            slidesToScroll: 1,		
            responsive: [
              {
                breakpoint: 9999,
                settings: "unslick"    

              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true,
                  arrows: false
                }
              }
            ]
          });*/

  //  } 
  // }

  // Activity region Custom Product Page
  $('.center').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
          centerMode: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
          centerMode: false
        }
      }
    ]
  });

  //Video slider tech specs  
  $('.tech-video-slider').slick({
    slide: 'div.video-slider',
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    infinite: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 6000,
    centerMode: true,
  
    responsive: [
      {
        breakpoint: 9999,
        settings: "slick"    

      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          centerMode: true,
          autoplay: true
        }
      },{
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          centerMode: true,
          arrows: true
        }
      }
    ]
  });

  var url = window.location.href;
  var producturl = url.substring(url.lastIndexOf('/') + 1);
  //console.log(producturl);
  if( producturl=="guard-2k-wi-fi-security-cameras-2-pack-certified-refurbished" || producturl == "defender-4mp-outdoor-wi-fi-ip-camera-with-16gb-sd-card?variant=32103014826087" || producturl =="guard-2k-wi-fi-security-cameras-3-pack-certified-refurbished" || producturl=="defender-4mp-outdoor-wi-fi-ip-camera-with-16gb-sd-card")
  {
    //Product Page Timer
    var productTimestart = new Date("June 23, 2021 00:00:00 EDT");
    var productTimeend = new Date("June 30, 2021 23:59:59 EDT");   
    if (currentTime.getTime() > productTimestart.getTime() && currentTime.getTime() <= productTimeend.getTime())
    {
      $(".product-timer").show();          
      const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;	  
      window.setInterval(function() {  
        var current = new Date();
        var distance = productTimeend - current;		
        if (current.getTime() > productTimeend.getTime()) {       
          $('.product-timer').hide();
        }else if (current.getTime() < productTimeend.getTime()){
          var product_days = Math.floor(distance / (1000 * 60 * 60 * 24));
          document.getElementById("product-days").innerHTML = product_days + " : ";
          var product_hours = Math.floor((distance % (day)) / (hour));
          document.getElementById("product-hours").innerHTML = product_hours + " : ";
          var product_sec = Math.floor((distance % (hour)) / (minute));		
          document.getElementById('product-minutes').innerText = product_sec + " : ";
          document.getElementById('product-seconds').innerText = Math.floor((distance % (minute)) / second);
        }	}, 0);
    } 
  }

  var url = window.location.href;
  var carturl = url.substring(url.lastIndexOf('/') + 1);
  //console.log(carturl);
  if( carturl=="cart")
  {
    //Cart Timer
    var Timestart = new Date("December 22, 2021 00:00:00 EDT");
    var Timeend = new Date("December 31, 2021 23:59:59 EDT");   
    if (currentTime.getTime() > Timestart.getTime() && currentTime.getTime() <= Timeend.getTime())
    {
      $("#limited-timer").show();          
      const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;	  
      window.setInterval(function() {  
        var current = new Date();
        var distance = Timeend - current;		
        if (current.getTime() < Timeend.getTime()) {
          var html_days = Math.floor(distance / (1000 * 60 * 60 * 24));
          document.getElementById("limited-days").innerHTML = html_days;
          var html_hours = Math.floor((distance % (day)) / (hour));
          document.getElementById("limited-hour").innerHTML = html_hours;
          var html_sec = Math.floor((distance % (hour)) / (minute));		
          document.getElementById('limited-min').innerText = html_sec;
          document.getElementById('limited-sec').innerText = Math.floor((distance % (minute)) / second);
        }else if (current.getTime() > Timeend.getTime()){
          $('#limited-timer').hide();
        }	}, 0);
    } 
  }

  $(".coupon .close").click(function() {
    $("#alert").hide();
    $("#camalert").hide();

  }); 

  //PopUp Video for Guard Pro
  if (anchor=="GuardPro"){
    //alert('Video');
    var PopupEmbedLink = "https://www.youtube.com/embed/84Qjd2kDCZA?&autoplay=1";
    $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+PopupEmbedLink+'" allowfullscreen allow="autoplay; encrypted-media"></iframe></div></div>');
    if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
      setTimeout(function() {
        $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
      }, 600);
    }
    $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
      $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
    });
    ev.preventDefault();  
  } 

  //Onclick adding custom notes to Notes Section.
  var NoteTimestart = new Date("October 22, 2021 00:00:00 EDT");
  var NoteTimeend = new Date("October 28, 2021 23:59:59 EDT");   
  if (currentTime.getTime() > NoteTimestart.getTime() && currentTime.getTime() <= NoteTimeend.getTime())
  {  
    //Notes section
    $(".cart-button").click(function(event){
      var text= $('#cart-notes').val();    
      if( text==''){            
        var textareaText = $('.cart-instructions textarea').val();
        var insertText = 'Price Drop';
        $('#cart-notes').empty().val(insertText + textareaText);
        //alert(test);         
      }
    });
  }

  //On Delete Hide Pop Up
  if(cart=='cart'){
    $(".cart-item-remove").click(function(event){
      //alert('Delete');
      //$('#Popup2to8CAM').addClass('some');

    });
  }

  //Exit intent pop-up 

  // Close button and opt out link functionality
  $("#dy-popup-1 .dy-popup-close, #dy-popup-1 .dy-popup-optout").click(function(){
    $("#dy-popup-overlay").remove();
    Cookies.set('exit_intent', '1', { expires: 1}); 
  });

  // Copy to clipboard
  $("#dy-popup-btn").click(function(){
    var copyText = document.getElementById("dy-voucher-code");
    copyText.select();
    document.execCommand("copy");
    document.getElementById("dy-popup-btn").innerText="Copied";
  });

  $(document).on('keyup',function(e) {
    if (e.keyCode == 27) {
      $("#dy-popup-overlay").remove();
    }
  });

  if (Cookies.get('exit_intent') != '1') {
    setTimeout(function(){
      $(document).on("mouseout", evt => {
        if(evt.toElement === null && evt.relatedTarget === null) {
          $(evt.currentTarget).off("mouseout");
          $("#dy-popup-overlay").css('display', 'flex');
        }
      });
    }, 3000);  // equals 50 seconds

  }

  
  //Add disable to input
  if(cart=='cart'){
    $('.variant-39623712145474 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39635310739522 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39635310673986 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39635310837826 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39635310903362 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39635356057666 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39635356123202 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39635356188738 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39647334989890 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39661192577090 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39661192773698 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39661192740930 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39661192675394 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39658246078530 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39725475135554 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39725646348354 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39725647134786 .number-input-field input[type=number]').attr('disabled', 'disabled');
    $('.variant-39725647429698 .number-input-field input[type=number]').attr('disabled', 'disabled');
  }

  //Cart Accessories Popup   
  $('.warranty-shop.popupProduct').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID          
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      }          
    });     
  }); 

  //Disclaimer
  var url = window.location.href;
  var disclamier = url.substring(url.lastIndexOf('/') + 1);
  //console.log(disclamier);

  if(disclamier=="1tb-professional-surveillance-hard-drive-certified-open-box"){
    $('.product-tabs').before('<div class="comp">Discounts available on bulk purchases. Please contact us for assistance. Please note that open box products may not be exactly as pictured.</div>');
  }

  if( disclamier=='vision-4k-camera-60ft-bnc-extension-cable-with-coupler' || disclamier=="60ft-bnc-extension-cable-with-coupler-unrolled-4kcbl60v29xop" || disclamier=="60-ft-bnc-cable" || disclamier=="defender-4k-wired-analog-camera-60ft-bnc-cable-4kcbl60"){
    $('.static-product').before('<div class="phone"><div class="note"><div class="desktop-lg-12 mobile-sm-12"><strong>Compatibility:</strong>To ensure you are choosing the proper BNC cable, please review the power supply compatibility below. <p>Compatible with Defender 4K Ultra & Defender Vision.</p></div></div></div>');
    $('.product-tabs').before('<div class="comp"><strong> Please review your systems compatibility below to make sure this is the right extension cable for your DVR.</strong></div>');

  }

  //Expert Review   
  $('.tech-reviews').slick({
    slide: 'div.list-item',
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false
        }
      },{
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true
        }
      }
    ]
  });

  //Remove EB from the HomePage
  $(".p-blocks .rich-text h1").text(function() {
    return $.trim($(this).text()).replace(/^(Exclusive Bundle:)/gi, '');
  });

  $(".Eb-blocks .product-title").text(function() {
    return $.trim($(this).text()).replace(/^(Exclusive Bundle:)/gi, '');
  });

}); 


//Page onload function
$(window).on('load', function () {        
  //Compare shougn button fix  
  var price= $('.template-product .shg-product .shg-product-price').text();
  //console.log(price);  
  var compare =  $('.template-product .shg-product .shg-product-compare-price').text();
  //console.log(compare); 

  if((price==compare)||(price>=compare)){
    //alert('Greater');
    $('.template-product .shg-product .shg-product-compare-price').hide();// Hide compare price 
  }   
  if(price<compare){
    //alert('less');
    $('.template-product .shg-product .shg-product-compare-price').show();// Show compare price 
  } 


  // get current time  0= Sunday, 1= Monday, 2= Tue, 3= Wed, 4= thu, 5= friday 6= sat
  // if day is mon-Fri and time is between 8am and 4pm
  //var d = new Date();

  var d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"}));
  var dayOfWeek = d.getDay();
  var hour = d.getHours();
  var mins = d.getMinutes();
  var status = 'live';

  if (dayOfWeek !== 0 && dayOfWeek !== 6 && hour >= 8 && hour < 16){   
    status = 'live';    
  }else{
    status = 'afterHours';
  }

  if (status=='live') {
    $('#launcher').show();
    $("#launcher").css("display","block");
  }else{
    $('.after-hours').show();
    $("#launcher").css("display","none");
  } 


});



$(document).ready(function(){
  $("#Product-bundle").click(function(event){
    if($("#BundleProductId").length > 0){
      jQuery.post('/cart/add.js', { items: [ { quantity: 1, id: $("#BundleProductId").val() } ] });
      setTimeout(function(){window.location.href="/cart"},300)
    }
  })
if($('.navigation a[href="'+window.location.pathname+'"]').hasClass("header-navigation-current")==false){
$('.navigation a[href="'+window.location.pathname+'"]').addClass("header-navigation-current");
}
});

$('.review_svg_PDP img').click(function() {
   $('li.tab-link').removeClass('current');
   $('div#tab-1').removeClass('current');
  $('div#tab-2').removeClass('current');
 $('li.tab-link:nth-child(3)').addClass('current');
  $('div#tab-3').addClass('current');
  $('div#tab-3').show();
   $('html, body').animate({
      scrollTop: $(".tab-content.current").offset().top
    }, 1000);
});
$('.review_svg_PDP_mob img').click(function() {
   $('li.tab-link').removeClass('current');
   $('div#tab-1').removeClass('current');
   $('div#tab-2').removeClass('current');
 $('li.tab-link:nth-child(3)').addClass('current');
  $('div#tab-3').addClass('current');
  $('div#tab-3').show();
   $('html, body').animate({
      scrollTop: $(".tab-content.current").offset().top
    }, 1000);
});

// open box hide accordions that have no products
$(document).ready(function(){
 $('.open-box .wired-category-row').each(function(){
  if ($(this).children().length < 1){
    $(this).parents('.Accordions').hide();
  }
 })
});

//  Open box new desktop accordion for whats is open box
$('.Accordions.open-box-desktop-only').click(function(){
  $(this).find('.title_tab').toggleClass('active');
  console.log($('.title_tab').hasClass('active'));
  if( $(this).find('.title_tab').hasClass('active') == true){
    $(this).find('.inner_content').css('display','block');
     $('html, body').animate({
      scrollTop: $(".inner_content").offset().top
    }, 1000);
  }
  else{
     $(this).find('.inner_content').css('display','none');
  }
});

// new js accordion for deals page accordions for 
  var $dealsTab = $('.deals .Accordion_item .title_tab');
  
    
$dealsTab.on('click', function(e) {
  e.preventDefault();
  if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    $(this).parent().find('.inner_content').css('display','none');
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
    $(this).parent().find('.inner_content').css('display','block');
      $(this).next().find('p').addClass('show');         	
    }
});

// Warranty remove functionality
// $('document').ready(function () {
//    $('.cart-title a').each(function(){
//      if( $(this).text().indexOf("Extended") != -1 ){
//      var warranty_wrt_prd_id = $(this).parents('.cart-item-product-wrap').find('.warranty_wrt_prd').attr('prod_id');
//       var warranty_qty_cart = $('.warranty_wrt_prd').length;
//         var product_qty_cart = $('.column.new-design').length;
//        if(warranty_qty_cart == 1 && product_qty_cart == 0){
//                   $.ajax({
//       type: 'POST',
//       url: '/cart/change.js',
//       data: {
//         id: warranty_wrt_prd_id,
//         quantity: 0
//       },
//       dataType: 'json',
//       success: function(data) {  
//         window.location.reload();
//         // Update the cart summary or perform any necessary actions after successful removal.
//         // You can use the `data` object to access the updated cart information.
//       }
//     })
//        }  
//      }
// })
// });


$('document').ready(function () {
  //   var lastVisitedPage = localStorage.getItem('lastVisitedPage');
  //   var targetURL;
  // $('.extended-warranties.accessories .wired-shop').click(function(){
  //   targetURL = $(this).parents('.product-form-has-spb').find('input').val();
  //    localStorage.setItem('lastVisitedPage', targetURL); 
  // });
//   var visitedPages = JSON.parse(localStorage.getItem('visitedPages')) || [];
//   $('.extended-warranties.accessories .wired-shop').click(function() {
//     var targetURL = $(this).parents('.product-form-has-spb').find('input').val();
//     visitedPages.push(targetURL);
//     localStorage.setItem('visitedPages', JSON.stringify(visitedPages));   
// });
//   $.each(visitedPages, function(index, value) {    
//     visitedPages.push(value);
//     });
  // Retrieve existing visitedPages array from local storage
  var visitedPages = JSON.parse(localStorage.getItem('visitedPages')) || [];
  $.each(visitedPages, function(index, value) {
  $('.warranty_wrt_prd').each(function(){
    var new_val_local = $(this).attr('prod_id');
    if(value == new_val_local){
      $(this).addClass('from_excluded')
    }
  })
  });
  $('.extended-warranties.accessories .wired-shop').click(function() {
    var targetURL = $(this).parents('.product-form-has-spb').find('input').val();
    visitedPages.push(targetURL);
    localStorage.setItem('visitedPages', JSON.stringify(visitedPages));
  });

  $('.cart-title a').each(function(){
     var warranty_wrt_prd_id2 = $(this).parents('.cart-item-product-wrap').find('.warranty_wrt_prd').attr('prod_id');
     var add_class_wrnty = $(this).parents('.cart-item-product-wrap').find('.warranty_wrt_prd');
      var warranty_qty_cart2 = $('.warranty_wrt_prd').length;
        var product_qty_cart2 = $('.column.new-design').length;
       if( product_qty_cart2 >= 1){        
             $('.column.new-design .blocks .warranty-shop').each(function(index){
            var warranty_wrt_id = $(this).attr('warranty_id');
           if(warranty_wrt_prd_id2 == warranty_wrt_id){
                     $(add_class_wrnty).addClass('retain');        
             // console.log(add_class_wrnty)
           }          
       })
       }
})
  $('.warranty_wrt_prd').each(function(value){        
              var final_remove_qty = $(this).parents('.cart-item-product-wrap').find('.cart-title a').text();
     var final_excluded_prd = $(this).parents('.cart-item-product').attr('item-sku');
var final_remove_qty_id = $(this).attr('prod_id');
   if( final_remove_qty.indexOf("Extended") != -1 && final_excluded_prd != "EBNS8MP2T16B16-2YRW" ){
    
    var musa = $(this).hasClass('retain');  
     var moses = $(this).hasClass('from_excluded');
                  if(musa == false && moses == false){
                    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: final_remove_qty_id,
        quantity: 0
      },
      dataType: 'json',
      success: function(data) {  
        window.location.reload();
        // Update the cart summary or perform any necessary actions after successful removal.
        // You can use the `data` object to access the updated cart information.
      }
    })
                  }
 }  
                            })

});


$('document').ready(function(){
  var url_sent = $('.modal-content iframe').attr('src');
  
  $('.modal').click(function(){
$('.modal-content iframe').attr('src', '');
  });
$('.prd_image_button a').click(function(){
$('.modal-content iframe').attr('src', url_sent);
  });
  $('.prd_image_button_new a').click(function(){
$('.modal-content iframe').attr('src', url_sent);
  });
    $('.prd_image_button_mob a').click(function(){ 
      $(this).parents().find('.modal .modal-content iframe').attr('src', url_sent);
  });
});